import React from 'react'
import { PageLink } from 'src/components/link'

import { useCartCount, useToggleCart } from 'src/context/siteContext'
import { Nav } from 'src/components/nav'

export const Header = ({ pathname }: { pathname: string }) => {
  const count = useCartCount()
  const toggleCart = useToggleCart()

  return (
    <div className='header__main js-header header--blewp rel'>
      <div className='container--xl header mxa px1 outer'>
        <div className='f x jcb aic'>
          <div>
            <PageLink to='/' className='mr1 s1  caps'>USBY.US/</PageLink>
          </div>
          <div>
            <button aria-label='cart' className='p0 no-style a s1 caps s1' onClick={() => toggleCart()}>
              Cart (<span className='s1'>{count}</span>)
            </button>
          </div>
        </div>
      </div>
      <Nav path={pathname === '/' ? 'index' : pathname} />
    </div>
  )
}
